import React from "react";
import SectionHeader from "../components/SectionHeader";

const CountryDirectorSection = ({ data }) => (
    <section className="country-directors" id="country-directors">

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                highlight={data.highlight}
                description={data.description}
            />


            {/* =================================================
                 ADVISORS
            ================================================== */}

            <div className="country-director-grid">

                {(data.items || []).map((item, i) => (

                    <article
                        className="country-director-card"
                        key={item.id || i}
                    >

                        {item.photo && (
                            <div className="country-director-photo">

                                <img
                                    src={item.photo}
                                    alt={item.alt || item.name}
                                />

                            </div>
                        )}

                        <div className="country-director-content">

                            <h3>
                                {item.name}
                            </h3>

                            {item.title && (
                                <p className="country-director-title">
                                    {item.title}
                                </p>
                            )}

                            {item.organization && (
                                <p className="country-director-organization">
                                    {item.organization}
                                </p>
                            )}

                            {item.country && (
                                <p className="country-director-country">
                                    {item.country}
                                </p>
                            )}

                            {item.bio && (
                                <p className="country-director-bio">
                                    {item.bio}
                                </p>
                            )}

                            {(item.website || item.linkedin) && (
                                <div className="country-director-links">

                                    {item.website && (
                                        <a
                                            href={item.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Website
                                        </a>
                                    )}

                                    {item.linkedin && (
                                        <a
                                            href={item.linkedin}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            LinkedIn
                                        </a>
                                    )}

                                </div>
                            )}

                        </div>

                    </article>

                ))}

            </div>

        </div>

    </section>
);

export default CountryDirectorSection;